import React, { useEffect, useCallback, useState, useContext } from 'react';
import { Modal, Spinner, Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import * as _ from 'lodash';
import { CHARGER_STATUS, CHARGER_STATUS_SILENT, CHARGER_STATUS_DOWNLOAD, FETCH_CHARGER_STATUS_WIDGETS, PUBNUB_STATUS_UPDATE, RESET_LIVE_MODE, SET_SELECTED_STATUSES } from 'actions/chargerStatus';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
import moment from 'moment';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { BiSort } from 'react-icons/bi';
import ReactPagination from 'components/general/ReactPagination';
import Select from 'components/inputs/Select';
import { MdClear } from 'react-icons/md';
import { Form, Formik } from 'formik';
import OffCanvas from 'components/inputs/OffCanvas';
import { UPDATE_STATUS_CODE, GET_PARTNER_NETWORK } from 'components/common/constant';
import { RiChargingPile2Line } from 'react-icons/ri';
import { GiLogicGateAnd } from 'react-icons/gi';
import { BsLightningCharge, BsPlug } from 'react-icons/bs';
import { MdPowerOff } from 'react-icons/md';
import { GoPlug, GoStop } from 'react-icons/go';
import { FiZapOff } from 'react-icons/fi';
import fileDownload from 'js-file-download';
import { BsDownload } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { RiEqualizerFill } from 'react-icons/ri';
import { FETCH_OEM_VENDOR } from 'actions/oemVendor';
import { FETCH_CHARGE_SPEED } from 'actions/chargeSpeed';
import { FETCH_CITY, FETCH_COUNTRY, FETCH_STATE } from 'actions/address';
import { FETCH_USER } from 'actions/user';
import VRNForm from './vinForm';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Footer from 'components/general/Footer';
import { BsPlugin } from 'react-icons/bs';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import ToggleSwitch from 'components/inputs/ToggleSwitch';
import { ADMIN, TENANT_ADMIN, SUPPORT } from 'components/common/constant';
import { toast } from 'react-toastify';
import LiveModeToggle from './components/LiveModeToggle';
import Tooltip from '@mui/material/Tooltip';
import pop from 'assets/audio/Pop.mp3';



const getToastType = (status) =>
  status === 'Available' ? 'success'
    : status === 'Charging' ? 'info'
      : ['Faulted', 'PowerLoss', 'Emergency stop pressed'].includes(status) ? 'error'
        : 'warning';

const calculateWidgetCounts = (chargers) => {
  let plugAvailable = 0;
  let plugUnavailable = 0;
  let plugCharging = 0;
  let plugFinishing = 0;
  let plugFaulted = 0;
  let plugPreparing = 0;

  let chargerTotal = 0;
  let chargerInUse = 0;
  let chargerAvailable = 0;
  let chargerUnavailable = 0;
  let chargerPowerLoss = 0;
  let chargerUnderMaintenance = 0;
  let chargerComingSoon = 0;
  let chargerEmergencyStop = 0;
  let chargerUnderVoltage = 0;
  let chargerOverVoltage = 0;

  (chargers || []).forEach((charger) => {
    const isDeleted = charger.is_deleted === true;
    const isActive = charger.is_active !== false;
    const isExternal = charger.is_external_charger === true;

    // Connectors / Plugs calculations
    const plugs = charger.plugs || [];
    plugs.forEach((plug) => {
      if (!isDeleted) {
        if (isActive && !isExternal) {
          if (plug.status === 'Available') {
            plugAvailable++;
          } else if (plug.status === 'Unavailable' || plug.status === undefined) {
            plugUnavailable++;
          } else if (plug.status === 'Charging') {
            plugCharging++;
          } else if (plug.status === 'Finishing') {
            plugFinishing++;
          } else if (plug.status === 'Faulted') {
            plugFaulted++;
          } else if (plug.status === 'Preparing') {
            plugPreparing++;
          }
        }
      }
    });

    if (charger.operational_status === 'UnderMaintenance') {
      plugUnavailable = Math.max(0, plugUnavailable - 1);
    }

    // Charger calculations
    if (!isDeleted && isActive) {
      chargerTotal++;

      const emergencyStopRegex = /^emergency stop pressed$/i;
      const voltageVarianceRegex = /^Input (Under|Over) Voltage$/i;

      const hasEmergencyStop =
        charger.charger_status === 'Unavailable' &&
        plugs.some((p) => emergencyStopRegex.test(p?.cpoErrorCode));

      const hasVoltageVariance =
        charger.charger_status === 'Unavailable' &&
        plugs.some((p) => voltageVarianceRegex.test(p?.cpoErrorCode));

      const isUnderMaintenance =
        charger.operational_status &&
        charger.operational_status.toLowerCase().includes('undermaintenance');

      const isComingSoon =
        charger.operational_status &&
        charger.operational_status.toLowerCase().includes('comingsoon');

      if (hasEmergencyStop) {
        chargerEmergencyStop++;
      }

      if (hasVoltageVariance) {
        if (plugs.some((p) => voltageVarianceRegex.test(p?.cpoErrorCode) && p?.cpoErrorCode?.includes('Under'))) {
          chargerUnderVoltage++;
        }
        if (plugs.some((p) => voltageVarianceRegex.test(p?.cpoErrorCode) && p?.cpoErrorCode?.includes('Over'))) {
          chargerOverVoltage++;
        }
      }

      if (isUnderMaintenance && charger.charger_status !== 'PowerLoss') {
        chargerUnderMaintenance++;
      }

      if (charger.charger_status === 'Available' && !isUnderMaintenance && !isComingSoon) {
        chargerAvailable++;
      }

      if (charger.charger_status === 'In Use') {
        chargerInUse++;
      }

      if (charger.charger_status === 'PowerLoss') {
        chargerPowerLoss++;
      }

      if (
        charger.charger_status === 'Unavailable' &&
        !isUnderMaintenance &&
        !isComingSoon &&
        !hasEmergencyStop &&
        !hasVoltageVariance
      ) {
        chargerUnavailable++;
      }

      if (isComingSoon) {
        chargerComingSoon++;
      }
    }
  });

  return {
    plugAvailable,
    plugUnavailable,
    plugCharging,
    plugFinishing,
    plugFaulted,
    plugPreparing,

    chargerTotal,
    chargerInUse,
    chargerAvailable,
    chargerUnavailable,
    chargerPowerLoss,
    chargerUnderMaintenance,
    chargerComingSoon,
    chargerEmergencyStop,
    chargerUnderVoltage,
    chargerOverVoltage,
  };
};

const matchStatus = (charger, status, isChecked) => {
  const plugs = charger.plugs || [];
  const isDeleted = charger.is_deleted === true;
  const isActive = charger.is_active !== false;
  const isExternal = charger.is_external_charger === true;

  if (isChecked) {
    if (isDeleted || !isActive || isExternal) {
      return false;
    }
    return plugs.some((plug) => {
      let plugStatus = plug.status;
      if (status === 'Available') {
        return plugStatus === 'Available';
      }
      if (status === 'Unavailable') {
        if (charger.operational_status === 'UnderMaintenance') {
          return false;
        }
        return plugStatus === 'Unavailable' || plugStatus === undefined;
      }
      if (status === 'Charging') {
        return plugStatus === 'Charging';
      }
      if (status === 'Finishing') {
        return plugStatus === 'Finishing';
      }
      if (status === 'Faulted') {
        return plugStatus === 'Faulted';
      }
      if (status === 'Preparing') {
        return plugStatus === 'Preparing';
      }
      return false;
    });
  }

  const emergencyStopRegex = /^emergency stop pressed$/i;
  const voltageVarianceRegex = /^Input (Under|Over) Voltage$/i;

  const hasEmergencyStop =
    charger.charger_status === 'Unavailable' &&
    plugs.some((p) => emergencyStopRegex.test(p?.cpoErrorCode));

  const hasVoltageVariance =
    charger.charger_status === 'Unavailable' &&
    plugs.some((p) => voltageVarianceRegex.test(p?.cpoErrorCode));

  const isUnderMaintenance =
    charger.operational_status &&
    charger.operational_status.toLowerCase().includes('undermaintenance');

  const isComingSoon =
    charger.operational_status &&
    charger.operational_status.toLowerCase().includes('comingsoon');

  if (status === 'underMaintenance') {
    return !!isUnderMaintenance && charger.charger_status !== 'PowerLoss';
  }
  if (status === 'comingSoon') {
    return !!isComingSoon;
  }
  if (status === 'Unavailable') {
    return (
      charger.charger_status === 'Unavailable' &&
      !isUnderMaintenance &&
      !isComingSoon &&
      !hasEmergencyStop &&
      !hasVoltageVariance
    );
  }
  if (status === 'Emergency stop pressed') {
    return hasEmergencyStop;
  }
  if (status === 'voltageVariance') {
    return hasVoltageVariance;
  }
  if (status === 'Available') {
    return (
      charger.charger_status === 'Available' &&
      !isUnderMaintenance &&
      !isComingSoon
    );
  }
  if (status === 'PowerLoss') {
    return charger.charger_status === 'PowerLoss';
  }
  if (status === 'In Use') {
    return charger.charger_status === 'In Use';
  }
  return charger.charger_status === status;
};

const ChargerStatus = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const history = useHistory();
  const { navigateTo, isAllowed } = useContext(NavContext);
  const [sortByItem, setSortByItem] = useState({ item: 'lastStatusUpdatedAt', order: 'desc' });
  const [searchText, setSearchText] = useState('');
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});
  const advanceFilterDataRef = React.useRef(advanceFilterData);
  useEffect(() => { advanceFilterDataRef.current = advanceFilterData; }, [advanceFilterData]);
  const [activeIndex, setActiveIndex] = useState(null);
  // const [allChargingStationData, setAllChargingStationData] = useState([]);
  const [currentTab, setCurrentTab] = useState(sessionStorage.getItem('tabActive') || 'normalCharger');

  const chargerStatusList = useSelector((state) => state.chargerStatus.chargerStatus);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const isLoader = useSelector((state) => state.chargerStatus.isLoading);
  const isSilentLoading = useSelector((state) => state.chargerStatus.isSilentLoading);
  // page, totalData, limit, totalPages overridden locally for client-side pagination
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const [showForm, setShowForm] = useState(false);
  const [gunId, setgunId] = useState('');
  const [chargeId, setChargeId] = useState('');
  const currentUserName = _.get(profileData, 'name', '');
  const userCompany = _.get(profileData, 'tenant.is_ocpi_charger_enabled');
  const [isChecked, setIsChecked] = useState(false);
  const isCheckedRef = React.useRef(false);
  useEffect(() => { isCheckedRef.current = isChecked; }, [isChecked]);
  const currentUserRole = _.get(profileData, 'role', '');

  const [expandedRowsByStation, setExpandedRowsByStation] = useState({});
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  useEffect(() => {
    if (!showSortDropdown) return;
    const close = () => setShowSortDropdown(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [showSortDropdown]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isLiveMode = useSelector((state) => state.chargerStatus.isLiveMode);
  const selectedStatuses = useSelector((state) => state.chargerStatus.selectedStatuses);
  const tenantId = _.get(profileData, 'tenant.id', '');
  const webSocketRef = React.useRef(null);
  const isLiveRef = React.useRef(isLiveMode);
  const selectedStatusesRef = React.useRef(selectedStatuses);

  useEffect(() => { isLiveRef.current = isLiveMode; }, [isLiveMode]);
  useEffect(() => { selectedStatusesRef.current = selectedStatuses; }, [selectedStatuses]);
  useEffect(() => { sortByRef.current = sortByItem; }, [sortByItem]);

  // Reset live mode on mount/unmount so notifications never persist across navigation
  useEffect(() => {
    dispatch({ type: RESET_LIVE_MODE });
    return () => {
      dispatch({ type: RESET_LIVE_MODE });
      clearTimeout(widgetRefreshTimer.current);
      clearTimeout(listRefreshTimer.current);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const audioRef = React.useRef(null);
  useEffect(() => { audioRef.current = new Audio(pop); }, []);

  // Debounced widget refresh — fires once after rapid WS updates settle (2s)
  const widgetRefreshTimer = React.useRef(null);
  const refreshWidgetsSilently = useCallback(() => {
    clearTimeout(widgetRefreshTimer.current);
    widgetRefreshTimer.current = setTimeout(() => {
      dispatch({
        type: FETCH_CHARGER_STATUS_WIDGETS.REQUEST,
        payload: {
          charging_station: userProfileStations,
          status: isCheckedRef.current,
          is_external: currentTabRef.current !== 'normalCharger',
        },
      });
    }, 2000);
  }, [dispatch, userProfileStations]);

  // Debounced list refresh — re-fetches current page/filter silently after WS updates settle (2s)
  const listRefreshTimer = React.useRef(null);
  const chargerStatusFnRef = React.useRef(null); // holds latest chargerStatus fn
  const sortByRef = React.useRef({ item: 'lastStatusUpdatedAt', order: 'desc' });
  const refreshListSilently = useCallback(() => {
    clearTimeout(listRefreshTimer.current);
    listRefreshTimer.current = setTimeout(() => {
      if (!chargerStatusFnRef.current) return;
      const { item, order } = sortByRef.current;
      const sortBy = `${order === 'asc' ? '' : '-'}${item}`;
      chargerStatusFnRef.current({ sortBy }, true);
    }, 2000);
  }, []);

  // Filter: only fire toast if charger status matches selected statuses
  const filterChargerUpdate = useCallback((chargerData) => {
    const current = selectedStatusesRef.current;
    if (current.length === 0) {
      return false;
    }
    if (current.includes('total')) {
      return true;
    }
    const updatedStatus = chargerData.charger_status || '';
    const match = current.includes(updatedStatus);
    return match;
  }, []);

  // Handle incoming charger update
  const handleChargerUpdate = useCallback((chargerData) => {
    if (!_.isObject(chargerData)) {
      console.warn('[CS] SKIPPED — not an object');
      return;
    }

    dispatch({ type: PUBNUB_STATUS_UPDATE, payload: chargerData });

    // Debounced silent refresh for both widget counts and the list
    refreshWidgetsSilently();
    refreshListSilently();

    const passes = filterChargerUpdate(chargerData);
    if (!passes) {
      return;
    }

    const updatedStatus = chargerData.charger_status || '';
    const stationName = _.get(chargerData, 'charging_station.name', chargerData.station_name || '');
    const plugs = _.get(chargerData, 'plugs', []);

    if (plugs.length > 0) {
      plugs.forEach((plug) => {
        const gunName = _.get(plug, 'name', _.get(plug, 'connector_id', ''));
        const gunStatus = _.get(plug, 'status', updatedStatus);
        toast(`Gun ${gunName} at ${stationName} is ${gunStatus}.`, {
          type: getToastType(gunStatus),
          autoClose: 6000,
          position: 'top-right',
        });
      });
    } else {
      toast(`Charger ${chargerData.charger_id || ''} at ${stationName} is ${updatedStatus}.`, {
        type: getToastType(updatedStatus),
        autoClose: 6000,
        position: 'top-right',
      });
    }

    if (['Faulted', 'PowerLoss', 'Unavailable', 'Emergency stop pressed'].includes(updatedStatus)) {
      audioRef.current?.play().catch((e) => console.warn('[CS] audio play failed:', e));
    }
  }, [dispatch, filterChargerUpdate, refreshWidgetsSilently, refreshListSilently]);

  // WebSocket live mode
  useEffect(() => {
    if (isLiveMode) {
      const wsUrl = `${process.env.REACT_APP_LIVE_CHARGING_SESSION}?tenant=${tenantId}`;
      const ws = new WebSocket(wsUrl);

      ws.onerror = (e) => console.error('[CS] WebSocket error:', e);

      ws.onmessage = (event) => {
        if (!isLiveRef.current) {
          return;
        }

        let parsed;
        try {
          parsed = JSON.parse(event.data);
        } catch (e) {
          console.error('[CS] WebSocket JSON parse failed:', e);
          return;
        }

        // Message structure: { topic: 'station_status_updated', data: { stationName, charger: {...} } }
        const topic = parsed.topic || '';
        const data = parsed.data || {};

        if (topic === 'station_status_updated' && data.charger) {
          // data.status carries the true event status (e.g. "Emergency Button Pressed")
          // which overrides charger_status ("Unavailable") for correct toast filtering
          const chargerStatus = data.charger.charger_status || data.charger.status || '';
          // data.status is station-level — normalize known station alerts for toast/filter matching
          const stationEventStatus = (data.status || '').toLowerCase();
          const resolvedStatus = stationEventStatus.includes('emergency')
            ? 'Emergency stop pressed'
            : stationEventStatus.includes('voltage variance')
              ? 'voltageVariance'
              : chargerStatus;
          // station name lives in data.stationId.name or data.stationName
          const stationName = data.stationId?.name || data.stationName || '';
          const chargerPayload = {
            ...data.charger,
            charger_status: resolvedStatus,
            charging_station: { name: stationName },
          };
          handleChargerUpdate(chargerPayload);
        } else if (topic === 'station_status_updated' && (data.status === 'Under Maintenance' || data.status === 'Coming Soon')) {
          // Station-level status change from CMS PATCH API — no charger payload, refresh list and show toast
          refreshWidgetsSilently();
          refreshListSilently();
          toast(`${data.stationName || 'Station'} is now ${data.status}.`, {
            type: 'warning',
            autoClose: 6000,
            position: 'top-right',
          });
        }
        // No topic or unhandled topic = booking/session update — ignore silently
      };

      webSocketRef.current = ws;

      return () => {
        ws.close();
        webSocketRef.current = null;
      };
    }
  }, [isLiveMode, tenantId, handleChargerUpdate, refreshWidgetsSilently, refreshListSilently]);




  const partnerNetworkPermission = !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_PARTNER_NETWORK),
      (data) => data.name
    );

  // Refs so chargerStatus never has stale closures for search or filter
  const searchTextRef = React.useRef(searchText);
  useEffect(() => { searchTextRef.current = searchText; }, [searchText]);

  const currentTabRef = React.useRef(currentTab);
  useEffect(() => { currentTabRef.current = currentTab; }, [currentTab]);

  const chargerStatus = useCallback(
    (value, silent = false) => {
      if (!silent) {
        setCurrentPage(1);
      }
      const activeFilter = chargerStatusRef.current || {};
      const advFilter = advanceFilterDataRef.current || {};
      let merged = { ...advFilter, ...activeFilter, ...value };
      if (value && value._clearAdvanceFilter) {
        merged = { ...activeFilter, ...value };
        delete merged._clearAdvanceFilter;
      }
      const currentSearch = searchTextRef.current;
      const isExternal = currentTabRef.current !== 'normalCharger';
      const payload = {
        ...merged,
        ...(currentSearch ? { search: currentSearch } : {}),
        is_external_station: isExternal,
      };
      delete payload.charger_availibity;
      dispatch({
        type: silent ? CHARGER_STATUS_SILENT.REQUEST : CHARGER_STATUS.REQUEST,
        payload,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            onCloseAdvanceFilterPopup();
          }
        },
      });
    },
    [dispatch]
  );
  // Keep ref in sync so refreshListSilently always calls the latest version
  useEffect(() => { chargerStatusFnRef.current = chargerStatus; }, [chargerStatus]);

  const setTab = (e, tab) => {
    e.preventDefault();
    setCurrentTab(tab);
    sessionStorage.setItem('tabActive', tab);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    const searchPayload = {
      sortBy: '-lastStatusUpdatedAt',
    };
    chargerStatus(searchPayload);
  };

  const handlevRNclick = (connectorId, chargerID) => {
    setShowForm(true);
    setChargeId(chargerID);
    setgunId(connectorId);
  };

  const getWidgets = useCallback(
    () => {
      // No-op: we compute counts on the frontend now!
    },
    []
  );

  useEffect(() => {
    getWidgets(isChecked);
  }, [currentTab, getWidgets]);

  useEffect(() => {
    if (chargerFilter) {
      if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
        chargerStatus(chargerFilter);
      } else {
        chargerStatus(chargerFilter);
      }
    } else {
      if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
        const data = {
          sortBy: '-lastStatusUpdatedAt',
          charging_station: userProfileStations,
        };
        chargerStatus(data);
      } else {
        const data = {
          sortBy: '-lastStatusUpdatedAt',
        };
        chargerStatus(data);
      }
    }
  }, [currentTab]);

  const downloadFile = () => {
    downloadChargerStatus();
  };

  const getSortByItem = useCallback(
    (name, order, page, filterDateData) => {
      const sortedOrder = order || 'asc';
      if (page) {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        chargerStatus(data);
      } else if (filterDateData) {
        const data = {
          ...filterDateData,
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        chargerStatus(data);
      } else {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        };
        chargerStatus(data);
      }
    },
    [chargerStatus]
  );

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const [chargerFilter, setChargerFilter] = useState('');
  const chargerStatusRef = React.useRef(chargerFilter);
  useEffect(() => { chargerStatusRef.current = chargerFilter; }, [chargerFilter]);

  const handlePageClick = useCallback(
    (page) => {
      setActiveIndex(null);
      setCurrentPage(page.selected + 1);
    },
    []
  );

  const downloadChargerStatus = useCallback(() => {

    // Base payload for downloading charger status
    let basePayload = {
      excel: true,
      is_external_station: currentTab !== 'normalCharger',
    };

    // Add search keyword to the payload if available
    if (searchText) {
      basePayload = { ...basePayload, search: searchText };
    }

    // Add advanced filters if available
    if (!_.isEmpty(advanceFilterData)) {
      basePayload = { ...basePayload, ...advanceFilterData };
    }

    // Add charger availability status (multi-select filter) if available
    if (chargerFilter && chargerFilter.charger_availibity) {
      basePayload = { ...basePayload, charger_availibity: chargerFilter.charger_availibity };
    } else if (selectedStatuses.length > 0 && !selectedStatuses.includes('total')) {
      // If no chargerFilter but selectedStatuses has individual statuses, use them
      basePayload = { ...basePayload, charger_availibity: selectedStatuses };
    }

    // Add sorting (default to latest issue first)
    basePayload = { ...basePayload, sortBy: sortByItem.order === 'desc' ? `-${sortByItem.item}` : sortByItem.item };

    // Dispatch the action with the constructed payload
    dispatch({
      type: CHARGER_STATUS_DOWNLOAD.REQUEST,
      payload: basePayload,
      cb: (res) => {
        if (res && _.get(res, 'status') === 200) {
          fileDownload(res.data, `${'Charger Status'}.xlsx`);
        }
      },
    });
  }, [currentTab, advanceFilterData, searchText, chargerFilter, selectedStatuses, sortByItem, dispatch]);

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);

  const allCountries = useSelector((state) => state.country.countries);
  const allState = useSelector((state) => state.state.states);
  const allCity = useSelector((state) => state.city.city);
  const allUsers = useSelector((state) => state.user.users) || [];
  const allOemVendor = useSelector((state) => state.oemVendor.oemVendors);
  const allChargeSpeed = useSelector((state) => state.chargeSpeed.chargeSpeed);
  const countryPage = useSelector((state) => state.country.page);
  const statePage = useSelector((state) => state.state.page);
  const cityPage = useSelector((state) => state.city.page);
  const countryTotalPage = useSelector((state) => state.country.totalPages);
  const stateTotalPage = useSelector((state) => state.state.totalPages);
  const cityTotalPage = useSelector((state) => state.city.totalPages);

  const initialValues = !_.isEmpty(advanceFilterData)
    ? { ...advanceFilterData }
    : { country: '', state: '', city: '', oem: '', charger_type: '', is_active: '', charger_availibity: '', access_type: '', zme: [], last_updated_filter: '' };

  const getAllCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_COUNTRY.REQUEST, payload: data });
  }, []);

  const getStateByCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_STATE.REQUEST, payload: data });
  }, []);

  const getCityByState = useCallback((data = {}) => {
    dispatch({ type: FETCH_CITY.REQUEST, payload: data });
  }, []);


  useEffect(() => {
    getAllCountry();
    dispatch({ type: FETCH_OEM_VENDOR.REQUEST, payload: { limit: 999 } });
    dispatch({ type: FETCH_CHARGE_SPEED.REQUEST });
    if (isAllowed('getUsers')) {
      dispatch({ type: FETCH_USER.REQUEST, payload: { role: 'ZMT', limit: 999 } });
    }
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 20;
  const page = currentPage;

  const counts = React.useMemo(() => {
    return calculateWidgetCounts(chargerStatusList || []);
  }, [chargerStatusList]);

  const totalcharger = counts.chargerTotal;
  const availableData = counts.chargerAvailable;
  const unavailableData = counts.chargerUnavailable;
  const inuseData = counts.chargerInUse;
  const powerlossCount = counts.chargerPowerLoss;
  const availableCount = counts.plugAvailable;
  const chargingCount = counts.plugCharging;
  const faultedCount = counts.plugFaulted;
  const finishingCount = counts.plugFinishing;
  const preparingCount = counts.plugPreparing;
  const emergencyStopCount = counts.chargerEmergencyStop;
  const underMaintenance = counts.chargerUnderMaintenance;
  const comingSoon = counts.chargerComingSoon;
  const unavailableCount = counts.plugUnavailable;
  const underVoltageCount = counts.chargerUnderVoltage;
  const overVoltageCount = counts.chargerOverVoltage;

  const filteredList = React.useMemo(() => {
    const isAll = selectedStatuses.length === 0 || selectedStatuses.includes('total');
    if (isAll) {
      return chargerStatusList || [];
    }
    return (chargerStatusList || []).filter((charger) => {
      return selectedStatuses.some((status) => matchStatus(charger, status, isChecked));
    });
  }, [chargerStatusList, selectedStatuses, isChecked]);

  const pagedList = React.useMemo(() => {
    const start = (currentPage - 1) * 20;
    return filteredList.slice(start, start + 20);
  }, [filteredList, currentPage]);

  const totalData = filteredList.length;
  const totalPages = Math.ceil(filteredList.length / 20) || 1;


  const getStatusFromCpoErrorCode = (status, cpoErrorCode) => {
    return cpoErrorCode.includes('Power Loss') ? 'Power Loss' : status;
  };
  const handleChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    // Reset status filter and search on toggle so counts match the new view
    setChargerFilter('');
    setSearchText('');
    dispatch({ type: SET_SELECTED_STATUSES, payload: [] });
    getWidgets(checked);
    chargerStatus({ sortBy: '-lastStatusUpdatedAt' });
  };

  const handleStatusToggle = (key) => {
    const current = selectedStatusesRef.current;
    let next;
    if (key === 'total') {
      next = current.includes('total') ? [] : ['total'];
    } else {
      const withoutTotal = current.filter((s) => s !== 'total');
      next = withoutTotal.includes(key)
        ? withoutTotal.filter((s) => s !== key)
        : [...withoutTotal, key];
    }

    dispatch({ type: SET_SELECTED_STATUSES, payload: next });
    setCurrentPage(1);
  };

  const handleManualRefresh = () => {
    if (chargerFilter) {
      chargerStatus(chargerFilter);
    } else {
      chargerStatus({});
    }
    getWidgets(isChecked);
  };





  return (

    <>
      <LayoutContainer>
        <AdminHeader title={t('header.chargerStatus')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            {[ADMIN, TENANT_ADMIN, SUPPORT].includes(currentUserRole) ? (
              <div>
                <div className="tab-block">
                  <div className="tab-nav-block">
                    <a
                      href="#"
                      className={`tab-nav__item ${currentTab === 'normalCharger' ? 'active' : ''}`}
                      onClick={(e) => {
                        setTab(e, 'normalCharger');
                      }}
                      data-content="tab-bookings"
                    >
                      {t('addChargerStatus.normalCharger')}
                    </a>
                    {userCompany === true && partnerNetworkPermission && partnerNetworkPermission.length > 0 && (
                      <a
                        href="#"
                        className={`tab-nav__item ${currentTab === 'OCPICharger' ? 'active' : ''}`}
                        onClick={(e) => {
                          setTab(e, 'OCPICharger');
                        }}
                        data-content="tab-transactions"
                      >
                        {t('addChargerStatus.ocpiCharger')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="wise_status" title="Switch Between Charger Wise Data and Connector Wise Data" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '16px', fontSize: '0.875rem' }}>
              {isAllowed('viewChargeSpotWiseStatus') ? (
                <>
                  {t('addChargerStatus.chargerwise')}
                  <ToggleSwitch id="toggle-switch" name="toggle-switch" checked={isChecked} onChange={(event) => handleChange(event)} />
                  {t('addChargerStatus.ChargePoint')}
                  <span style={{ margin: '0 8px', color: '#2e3d4e' }}>|</span>
                </>
              ) : null}
              <LiveModeToggle onManualRefresh={handleManualRefresh} showWarning={selectedStatuses.length === 0} />
            </div>
            {isChecked ? (
              <div className="status-blocks">
                {[
                  { key: 'Available', count: availableCount, label: t('addChargerStatus.available'), icon: <RiChargingPile2Line className="icon-inner-color" size={35} />, bg: '' },
                  { key: 'Preparing', count: preparingCount, label: t('addChargerStatus.preparingCount'), icon: <RiChargingPile2Line className="icon-inner-color" size={35} />, bg: '' },
                  { key: 'Charging', count: chargingCount, label: t('addChargerStatus.charging'), icon: <GiLogicGateAnd className="icon-inner-color" size={35} />, bg: '' },
                  { key: 'Finishing', count: finishingCount, label: t('addChargerStatus.finishingCount'), icon: <BsLightningCharge className="icon-inner-color" size={35} />, bg: '' },
                  { key: 'Faulted', count: faultedCount, label: t('addChargerStatus.faultedCount'), icon: <GiLogicGateAnd className="icon-inner-color" size={35} />, bg: '' },
                  { key: 'Unavailable', count: unavailableCount, label: t('addChargerStatus.unavailable'), icon: <MdPowerOff className="icon-inner-color" size={35} />, bg: '' },
                ].map(({ key, count, label, icon, bg }) => (
                  <div
                    key={key}
                    className="status-block"
                    title={label}
                    onClick={() => handleStatusToggle(key)}
                    style={selectedStatuses.includes(key) ? { outline: '2px solid rgba(255,255,255,0.5)', filter: 'brightness(1.15)' } : {}}
                  >
                    <div className="breating-area" style={bg ? { background: bg } : {}}>
                      {isLoader ? <Skeleton circle="true" height={24} width={24} /> : icon}
                    </div>
                    <div className="status-info">
                      <h1>{isLoader ? <Skeleton height={15} width={100} /> : count || 0}</h1>
                      <p>{isLoader ? <Skeleton height={15} width={100} /> : label}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="status-blocks">
                {[
                  { key: 'total', count: totalcharger, label: t('addChargerStatus.total'), icon: <RiChargingPile2Line color="#FF8B00" size={35} />, bg: '#ff8b001a' },
                  { key: 'In Use', count: inuseData, label: t('addChargerStatus.inUse'), icon: <GiLogicGateAnd color="#4975F2" size={35} />, bg: '#3c7cdd1a' },
                  { key: 'Available', count: availableData, label: t('addChargerStatus.available'), icon: <BsPlug color="#14AC7F" size={35} />, bg: '#14ac7f1a' },
                  { key: 'Unavailable', count: unavailableData, label: t('addChargerStatus.unavailable'), icon: <BsPlug color="#FF8B00" size={35} />, bg: '#ff8b001a' },
                  { key: 'PowerLoss', count: powerlossCount, label: t('addChargerStatus.powerlossCount'), icon: <FiZapOff color="#BE210B" size={35} />, bg: '#be210b21' },
                  { key: 'underMaintenance', count: underMaintenance, label: t('stationDetails.underMaintenance'), icon: <GoStop color="#C9A11B" size={35} />, bg: '#c9a11b1a' },
                  { key: 'comingSoon', count: comingSoon, label: t('stationDetails.comingsoon'), icon: <GoStop color="#C9A11B" size={35} />, bg: '#c9a11b1a' },
                  { key: 'Emergency stop pressed', count: emergencyStopCount, label: t('addChargerStatus.emergencyStopCount'), icon: <GoStop color="#C9A11B" size={35} />, bg: '#c9a11b1a' },
                  { key: 'voltageVariance', count: Math.floor((underVoltageCount || 0) + (overVoltageCount || 0)), label: t('addChargerStatus.voltageVariance'), icon: <GoPlug color="#FF8B00" size={35} />, bg: '#ff8b001a' },
                ].map(({ key, count, label, icon, bg }) => (
                  <div
                    key={key}
                    className="status-block"
                    title={label}
                    onClick={() => handleStatusToggle(key)}
                    style={selectedStatuses.includes(key) ? { outline: '2px solid rgba(255,255,255,0.5)', filter: 'brightness(1.15)' } : {}}
                  >
                    <div className="breating-area" style={{ background: bg }}>
                      {isLoader ? <Skeleton circle="true" height={24} width={24} /> : icon}
                    </div>
                    <div className="status-info">
                      <h1>{isLoader ? <Skeleton height={15} width={100} /> : count || 0}</h1>
                      <p>{isLoader ? <Skeleton height={15} width={100} /> : label}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="data-report--main">
              <div className="data-report--block">
                <Card>
                  <div className="data-report__inner">
                    <div className="data-report__box">
                      <Row className="data-report__row">
                        <Col xl={9} lg={9} md={9} className="search_box_div">
                          <SearchBox
                            value={searchText}
                            preIcon={<BsSearch />}
                            placeholder={selectedStatuses.length > 1
                              ? 'Search by Status + Station Name'
                              : 'Search by Station Name'}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handleSearch();
                              }
                            }}
                          />
                        </Col>
                        <Col xl={'3'} md={'3'} className="search_btn_download">
                          <div className="report-search-box" onClick={handleSearch} title="Search">
                            <Button className="report-search-button"> {t('addChargerStatus.search')}</Button>
                          </div>
                          {isAllowed('downloadChargerStatus') && (
                            <div className="excel-icon--block" onClick={downloadFile} title="Download">
                              {isLoading ? (
                                <div className="loader--block">
                                  <Spinner as="span" animation="border" size="sm" role="status" />
                                </div>
                              ) : (
                                <div className="report-excel-icon">
                                  <BsDownload title="Download" size={28} color={'#FFFFFF'} />
                                </div>
                              )}
                            </div>
                          )}
                          <div className="advance-filter-icon" title="Open Advance Filter">
                            <RiEqualizerFill size={28} color={'#FFFFFF'} onClick={() => setShowAdvanceFilterPopup(true)} />
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {isSilentLoading && (
                      <div style={{ height: 3, background: 'linear-gradient(90deg, #3c7cdd 0%, #14ac7f 100%)', borderRadius: 2, marginBottom: 4, animation: 'pulse 1s infinite' }} />
                    )}
                    <div className="data-report__table">
                      <div className="table-responsive">
                        <table className="record-list-table chargerstatus-list-table" id="table-to-xls">
                          {windowWidth >= 769 ? (<thead>
                            <tr className="charger-status-header">
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.stationName')}</span>
                                  <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.ocppID')}</span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : 'ZME Name'}</span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.connectors')}</span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.cpoCode')}</span>
                                </div>
                              </th>
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.status')}</span>
                                  <span className="ico" onClick={() => handleSorting('status', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                              <th className="th-last-updated">
                                <div className="sorting" style={{ position: 'relative' }}>
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.lastUpdated')}</span>
                                  <span
                                    className="ico"
                                    onClick={(e) => { e.stopPropagation(); setShowSortDropdown((v) => !v); }}
                                    style={{ cursor: 'pointer' }}
                                    title="Sort by date"
                                  >
                                    <BiSort size={15} />
                                  </span>
                                  {showSortDropdown && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: 0,
                                        background: '#1b2a38',
                                        border: '1px solid #2e3d4e',
                                        borderRadius: 6,
                                        zIndex: 100,
                                        minWidth: 140,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                                      }}
                                    >
                                      {[
                                        { label: 'Recent First', order: 'desc' },
                                        { label: 'Oldest First', order: 'asc' },
                                      ].map(({ label, order }) => (
                                        <div
                                          key={order}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSortByItem({ item: 'lastStatusUpdatedAt', order });
                                            getSortByItem('lastStatusUpdatedAt', order);
                                            setShowSortDropdown(false);
                                          }}
                                          style={{
                                            padding: '8px 14px',
                                            cursor: 'pointer',
                                            fontSize: '0.8rem',
                                            color: sortByItem.item === 'lastStatusUpdatedAt' && sortByItem.order === order ? '#3c7cdd' : '#c8d6e5',
                                            fontWeight: sortByItem.item === 'lastStatusUpdatedAt' && sortByItem.order === order ? 600 : 400,
                                            background: 'transparent',
                                          }}
                                          onMouseEnter={(e) => e.currentTarget.style.background = '#243547'}
                                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        >
                                          {label}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </th>
                              {currentTab === 'normalCharger' ? <th colSpan={2}></th> : ''}
                            </tr>
                          </thead>) : null}
                          <tbody>
                            <tr>
                              <td colSpan={6}>
                                <div className="station-table-container">
                                  {isLoader ? (
                                    <tr>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                      <td>
                                        <Skeleton height={15} />
                                      </td>
                                    </tr>
                                  ) : _.isEmpty(filteredList) ? (
                                    <tr>
                                      <td colSpan={6} className="border-0">
                                        <div className="empty-data-block">{t('addChargerStatus.noData')}</div>
                                      </td>
                                    </tr>
                                  ) : (
                                    !(isLoader || _.isUndefined(isLoader)) &&
                                    _.map(pagedList, (item1, index1) => {
                                      const globalIndex = index1;
                                      const serial_num = 20 * (currentPage - 1) + index1;
                                      const isPowerLoss = _.get(item1, 'charger_status', '') === 'PowerLoss';
                                      const chargingStation = _.get(item1, 'charging_station', {});

                                      return (
                                        <React.Fragment key={`charger-status-${serial_num}`}> {
                                          windowWidth >= 769 ? <div className="charger-status-tr">
                                            <tr>
                                              <td
                                                className="station-link"
                                                onClick={() =>
                                                  navigateTo(
                                                    `/stations/${_.get(chargingStation, '_id', _.get(chargingStation, 'id', ''))}`,
                                                    { state: { backTo: 'chargerStatus' } }
                                                  )}
                                              >
                                                <RiChargingPile2Line color="#3c7cdd" size={35} />
                                                {isLoader ? <Skeleton height={15} width={100} /> : <span> {_.get(chargingStation, 'name', '')}</span>}
                                              </td>
                                              <td
                                                className={currentTab !== 'OCPICharger' ? 'charger-link' : ''}
                                                onClick={
                                                  currentTab !== 'OCPICharger'
                                                    ? () => navigateTo(`/charger/${_.get(item1, '_id', _.get(item1, 'id', ''))}`, { state: { backTo: 'chargerStatus' } })
                                                    : null
                                                }
                                              >
                                                {isLoader ? <Skeleton height={15} width={100} /> : _.get(item1, 'charger_id', '')}
                                              </td>
                                              <td>
                                                {isLoader ? <Skeleton height={15} width={100} /> : <span>{_.get(item1, 'zme_name', '-')}</span>}
                                              </td>
                                              <td>
                                                <div className="connector-wrapper">
                                                  {_.map(_.get(item1, 'plugs'), (item2, index2) => {
                                                    const isCharging = _.get(item2, 'status', '') === 'Charging';
                                                    const isPreparing = _.get(item2, 'status', '') === 'Preparing';
                                                    const isFinishing = _.get(item2, 'status', '') === 'Finishing';
                                                    const isAvailable = _.get(item2, 'status', '') === 'Available';
                                                    const isUnavailable = _.get(item2, 'status', '') === 'Unavailable';
                                                    const isFaulted = _.get(item2, 'status', '') === 'Faulted';
                                                    const name = _.get(item2, 'name', '');
                                                    const hasMoreThanOneLetter = name.length > 1;

                                                    let className = 'connector-circle';
                                                    if (isCharging) {
                                                      className += ' charging';
                                                    } else if (isAvailable) {
                                                      className += ' available';
                                                    } else if (isUnavailable && isPowerLoss) {
                                                      className += ' PowerLoss';
                                                    } else if (isFaulted && isPowerLoss) {
                                                      className += ' PowerLoss';
                                                    } else if (isPreparing || isFinishing) {
                                                      className += ' preparing';
                                                    } else {
                                                      className += ' unavailable';
                                                    }

                                                    if (hasMoreThanOneLetter) {
                                                      className += ' more-than-one-letter';
                                                    }

                                                    const errorCode = _.get(item2, 'errorCode', '');
                                                    const cpoErrorCode = _.get(item2, 'cpoErrorCode', '');
                                                    const gunName = _.get(item2, 'name', '') || _.get(item2, 'connector_id', '');
                                                    const tooltipLines = [
                                                      gunName ? `Gun ${gunName}` : null,
                                                      errorCode && errorCode !== 'NoError' ? `Error: ${errorCode}` : null,
                                                      cpoErrorCode ? `CPO: ${cpoErrorCode}` : null,
                                                    ].filter(Boolean);
                                                    const tooltipTitle = tooltipLines.join(' | ') || '';

                                                    return (
                                                      <Tooltip key={index2} title={tooltipTitle} arrow placement="top" disableHoverListener={!gunName && !tooltipTitle}>
                                                        <div className={className}>
                                                          {isLoader ? <Skeleton height={15} width={100} /> : <BsPlugin size={28} />}
                                                        </div>
                                                      </Tooltip>
                                                    );
                                                  })}
                                                </div>
                                              </td>
                                              <td>
                                                <div className="charger-link">
                                                  {isLoader ? (
                                                    <Skeleton height={15} width={100} />
                                                  ) : (
                                                    _.get(item1, 'plugs', [])
                                                      .map((plug) => plug.cpoErrorCode)
                                                      .find((cpoErrorCode) => cpoErrorCode) || '-'
                                                  )}
                                                </div>
                                              </td>
                                              <td>
                                                <div className={`status_charger status-${_.get(item1, 'charger_status')}`}>
                                                  {isLoader ? <Skeleton height={15} width={100} /> : _.get(item1, 'charger_status', '')}
                                                </div>
                                              </td>
                                              <td>
                                                {isLoader ? (
                                                  <Skeleton height={15} width={100} />
                                                ) : (
                                                  moment
                                                    .utc(_.get(item1, 'lastStatusUpdatedAt', _.get(item1, 'updatedAt', '')))
                                                    .local()
                                                    .format('DD/MM/YYYY H:mm:ss')
                                                )}{' '}
                                              </td>
                                              {currentTab === 'normalCharger' ? (
                                                <td className="dropdown-link" colSpan={2}>
                                                  {activeIndex === globalIndex ? (
                                                    <FaChevronUp size={28} onClick={() => setActiveIndex(null)} title="Collapse" />
                                                  ) : (
                                                    <FaChevronDown size={28} onClick={() => setActiveIndex(globalIndex)} title="Expand" />
                                                  )}
                                                </td>
                                              ) : (
                                                ''
                                              )}

                                            </tr>
                                            {/* rechanged code for table */}
                                            {activeIndex === globalIndex && (
                                              <tr className="sub-table">
                                                <React.Fragment>
                                                  <table>
                                                    {/* sub-table-head-row */}
                                                    <tr className="sub-table-head-row" style={{ backgroundColor: '#141f29' }}>

                                                      <th>
                                                        <div className="sorting">
                                                          <span>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.connectors')}
                                                          </span>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="sorting">
                                                          <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.status')}</span>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="sorting">
                                                          <span>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.errorCode')}
                                                          </span>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="sorting">
                                                          <span>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.venderErrorCode')}
                                                          </span>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="sorting">
                                                          <span>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.errorInfo')}
                                                          </span>
                                                        </div>
                                                      </th>
                                                      <th>
                                                        <div className="sorting">
                                                          <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.cpoCode')}</span>
                                                        </div>
                                                      </th>
                                                      {isAllowed('viewVRN') ? (
                                                        <th>
                                                          <div>
                                                            <span>
                                                              {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.action')}
                                                            </span>
                                                          </div>
                                                        </th>
                                                      ) : (
                                                        ''
                                                      )}
                                                    </tr>
                                                    {/* sub-table-body-row */}
                                                    {_.map(_.get(item1, 'plugs'), (item3, index3) => {
                                                      const isCharging = _.get(item3, 'status', '') === 'Charging';
                                                      const isPreparing = _.get(item3, 'status', '') === 'Preparing';
                                                      const isFinishing = _.get(item3, 'status', '') === 'Finishing';
                                                      const isAvailable = _.get(item3, 'status', '') === 'Available';
                                                      const isUnavailable = _.get(item3, 'status', '') === 'Unavailable';
                                                      const isFaulted = _.get(item3, 'status', '') === 'Faulted';

                                                      const name = _.get(item3, 'name', '');
                                                      const hasMoreThanOneLetter = name.length > 1;
                                                      let connectorClassName = 'connector-circle';
                                                      if (isCharging || isPreparing || isFinishing) {
                                                        connectorClassName += 'connector-charging';
                                                      } else if (!isAvailable) {
                                                        connectorClassName += 'connector-unavailable';
                                                      }

                                                      let statusClassName = '';
                                                      if (isCharging) {
                                                        statusClassName = 'charging';
                                                      } else if (isAvailable) {
                                                        statusClassName = 'available';
                                                      } else if (isUnavailable && isPowerLoss) {
                                                        statusClassName = 'PowerLoss';
                                                      } else if (isFaulted && isPowerLoss) {
                                                        statusClassName = 'PowerLoss';
                                                      } else if (isPreparing || isFinishing) {
                                                        statusClassName = 'preparing';
                                                      } else {
                                                        statusClassName = 'unavailable';
                                                      }
                                                      return (
                                                        <tr key={index3} className="sub-table-body-row">

                                                          <td style={{ backgroundColor: '#141f29' }}>
                                                            <div className="connector-wrapper">
                                                              <div
                                                                className={
                                                                  hasMoreThanOneLetter
                                                                    ? `${connectorClassName} more-than-one-letter`
                                                                    : connectorClassName
                                                                }
                                                              >
                                                                {isLoader ? <Skeleton height={15} width={100} /> : name}
                                                              </div>
                                                            </div>
                                                          </td>
                                                          <td className={statusClassName} style={{ backgroundColor: '#141f29' }}>
                                                            <BsPlugin size={28} />
                                                            {isLoader ? (
                                                              <Skeleton height={15} width={100} />
                                                            ) : (
                                                              getStatusFromCpoErrorCode(_.get(item3, 'status', ''), _.get(item3, 'cpoErrorCode', ''))
                                                            )}
                                                          </td>
                                                          <td style={{ backgroundColor: '#141f29' }}>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : _.get(item3, 'errorCode', '')}
                                                          </td>
                                                          <td style={{ backgroundColor: '#141f29' }}>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : _.get(item3, 'errorMessage', '')}
                                                          </td>
                                                          <td style={{ backgroundColor: '#141f29' }}>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : _.get(item3, 'errorInfo', '')}
                                                          </td>
                                                          <td style={{ backgroundColor: '#141f29' }}>
                                                            {isLoader ? <Skeleton height={15} width={100} /> : _.get(item3, 'cpoErrorCode', '')}
                                                          </td>
                                                          {isAllowed('viewVRN') ? (
                                                            <td style={{ backgroundColor: '#141f29' }}>
                                                              {isCharging ? (
                                                                <div
                                                                  className="report-search-box"
                                                                  onClick={() => handlevRNclick(_.get(item3, 'connector_id'), _.get(item1, 'id', ''))}
                                                                >
                                                                  <Button className="report-search-button">{t('addChargerStatus.addVIN')}</Button>
                                                                </div>
                                                              ) : (
                                                                ''
                                                              )}
                                                            </td>
                                                          ) : (
                                                            ''
                                                          )}
                                                        </tr>
                                                      );
                                                    })}
                                                  </table>
                                                </React.Fragment>
                                              </tr>
                                            )

                                            }
                                          </div>
                                            :


                                            <div className="mobile-card">

                                              <div className="station-header">
                                                <div
                                                  className="station-link"
                                                  onClick={() =>
                                                    navigateTo(`/stations/${_.get(chargingStation, '_id', _.get(chargingStation, 'id', ''))}`, { state: { backTo: 'chargerStatus' } })
                                                  }
                                                >
                                                  <RiChargingPile2Line color="#3c7cdd" size={35} />
                                                  {isLoader ? (
                                                    <Skeleton height={15} width={100} />
                                                  ) : (
                                                    <span className="station-name-clamp">{_.get(chargingStation, 'name', '')}</span>
                                                  )}
                                                </div>
                                                <div className={`status_charger status-${_.get(item1, 'charger_status')}`}>
                                                  {isLoader ? <Skeleton height={15} width={100} /> : _.get(item1, 'charger_status', '')}
                                                </div>
                                              </div>

                                              <div className="charger-header-row2">

                                                <div className='lastupdatedat-div' >
                                                  <div className="sorting" style={{ marginRight: '4px', paddingBottom: '5px' }}>
                                                    <span>
                                                      {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.lastUpdated')}:
                                                    </span>
                                                  </div>
                                                  {isLoader ? (
                                                    <Skeleton height={30} width={100} />
                                                  ) : (
                                                    moment
                                                      .utc(_.get(item1, 'lastStatusUpdatedAt', _.get(item1, 'updatedAt', '')))
                                                      .local()
                                                      .format('DD/MM H:mm:ss')
                                                  )}{' '}
                                                </div>
                                                <div className='ocpi-div'>
                                                  <div className="sorting">
                                                    <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.ocppID')}</span>
                                                  </div>

                                                  <div
                                                    className={`${currentTab !== 'OCPICharger' ? 'charger-link' : ''} force-flex text-wrap`}
                                                    onClick={
                                                      currentTab !== 'OCPICharger'
                                                        ? () => navigateTo(`/charger/${_.get(item1, '_id', _.get(item1, 'id', ''))}`, { state: { backTo: 'chargerStatus' } })
                                                        : null
                                                    }
                                                  >

                                                    {isLoader ? (
                                                      <Skeleton height={15} width={100} />
                                                    ) : (
                                                      <span className="charger-id-wrap">
                                                        {_.get(item1, 'charger_id', '').split('_').map((part, index, arr) => (
                                                          <React.Fragment key={index}>
                                                            {index > 0 && '_'}
                                                            {part}
                                                            {index < arr.length - 1 && <wbr />}
                                                          </React.Fragment>
                                                        ))}
                                                      </span>
                                                    )}

                                                  </div>

                                                </div>

                                                <div className='cpocode-div'>
                                                  <div className="sorting">
                                                    <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.cpoCode')}</span>
                                                  </div>

                                                  <div className="charger-link center-flex">
                                                    {isLoader ? (
                                                      <Skeleton height={15} width={100} />
                                                    ) : (
                                                      _.get(item1, 'plugs', [])
                                                        .map((plug) => plug.cpoErrorCode)
                                                        .find((cpoErrorCode) => cpoErrorCode) || '-'
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="sub-table-card">

                                                {_.map(_.get(item1, 'plugs'), (item3) => {
                                                  const stationId = item1.id;
                                                  const connectorId = _.get(item3, 'connector_id');
                                                  const expandedConnectors = expandedRowsByStation[stationId] || new Set();
                                                  const isExpanded = expandedConnectors.has(connectorId);

                                                  const isCharging = _.get(item3, 'status', '') === 'Charging';
                                                  const isPreparing = _.get(item3, 'status', '') === 'Preparing';
                                                  const isFinishing = _.get(item3, 'status', '') === 'Finishing';
                                                  const isAvailable = _.get(item3, 'status', '') === 'Available';
                                                  const isUnavailable = _.get(item3, 'status', '') === 'Unavailable';
                                                  const isFaulted = _.get(item3, 'status', '') === 'Faulted';
                                                  const name = _.get(item3, 'name', '');
                                                  const hasMoreThanOneLetter = name.length > 1;


                                                  let connectorClassName = 'connector-circle';
                                                  if (isCharging || isPreparing || isFinishing) {
                                                    connectorClassName += ' connector-charging';
                                                  } else if (!isAvailable) {
                                                    connectorClassName += ' connector-unavailable';
                                                  }


                                                  let statusClassName = '';
                                                  if (isCharging) statusClassName = 'charging';
                                                  else if (isAvailable) statusClassName = 'available';
                                                  else if ((isUnavailable || isFaulted) && isPowerLoss) statusClassName = 'PowerLoss';
                                                  else if (isPreparing || isFinishing) statusClassName = 'preparing';
                                                  else statusClassName = 'unavailable';

                                                  const toggleExpand = () => {
                                                    setExpandedRowsByStation(prev => {
                                                      const currentSet = new Set(prev[stationId] || []);
                                                      if (currentSet.has(connectorId)) {
                                                        currentSet.delete(connectorId);
                                                      } else {
                                                        currentSet.add(connectorId);
                                                      }
                                                      return { ...prev, [stationId]: currentSet };
                                                    });
                                                  };


                                                  return (
                                                    <React.Fragment key={`${stationId}-${connectorId}`}>
                                                      <tr className="sub-table-body-row" onClick={toggleExpand} style={{ cursor: 'pointer', height: '2rem' }}>
                                                        <div className='connector-div' >
                                                          <div className="connector-wrapper"  >
                                                            <div
                                                              className={
                                                                hasMoreThanOneLetter
                                                                  ? `${connectorClassName} status-${getStatusFromCpoErrorCode(_.get(item3, 'status', ''), _.get(item3, 'cpoErrorCode', ''))}-background more-than-one-letter`
                                                                  : `${connectorClassName} status-${getStatusFromCpoErrorCode(_.get(item3, 'status', ''), _.get(item3, 'cpoErrorCode', ''))}-background`
                                                              }
                                                              style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                maxWidth: '150px',
                                                              }}
                                                            >
                                                              {isLoader ? (
                                                                <Skeleton height={15} width={100} />
                                                              ) : (
                                                                <span
                                                                  title={name}
                                                                  style={{
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    display: 'inline-block',
                                                                    maxWidth: '100%',
                                                                    fontSize: '0.6rem'
                                                                  }}
                                                                >
                                                                  {name.length > 15 ? `${name.slice(0, 15)}...` : name}
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>


                                                        </div>
                                                        <div className={statusClassName} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0px' }}>

                                                          {isLoader ? (
                                                            <Skeleton height={15} width={100} />
                                                          ) : (
                                                            getStatusFromCpoErrorCode(_.get(item3, 'status', ''), _.get(item3, 'cpoErrorCode', ''))
                                                          )}
                                                        </div>

                                                        <div className="arrow-container">
                                                          <div className={`dropdown-arrow ${expandedRowsByStation[stationId]?.has(connectorId) ? 'rotate' : ''}`} />
                                                        </div>

                                                      </tr>

                                                      {isExpanded && (
                                                        <tr>

                                                          <div className="error-details connector-dropdown">
                                                            <div className="dropdown-errorcode">
                                                              <div className="sorting" style={{ backgroundColor: '#141f29', fontSize: '0.6rem' }}>
                                                                {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.errorCode')}
                                                              </div>  {`: ${_.get(item3, 'errorCode', '-')}`}
                                                            </div>

                                                            <div className="dropdown-vendorerrorcode">
                                                              <div className="sorting" style={{ backgroundColor: '#141f29', fontSize: '0.6rem' }}>
                                                                {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.venderErrorCode')}
                                                              </div>  {`: ${_.get(item3, 'errorMessage', '-')}`}
                                                            </div>


                                                            <div className="dropdown-errorinfo">
                                                              <div className="sorting" style={{ backgroundColor: '#141f29', fontSize: '0.6rem' }}>
                                                                {isLoader ? <Skeleton height={15} width={100} /> : t('addChargerStatus.errorInfo')}
                                                              </div>  {`: ${_.get(item3, 'errorInfo', '-')}`}
                                                            </div>
                                                          </div>

                                                        </tr>
                                                      )}
                                                    </React.Fragment>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                        }
                                        </React.Fragment>
                                      );
                                    })
                                  )
                                  }
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {!isLoader && !isLiveMode && !_.isEmpty(chargerStatusList) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={handlePageClick}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                  </div>
                </Card>
              </div>
            </div >
            {currentUserName === 'CZ Tenant Admin' ? null : <Footer />
            }
          </div >
        </SkeletonTheme >
      </LayoutContainer >
      {showAdvanceFilterPopup && (
        <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
          <Formik
            enableReinitialize={!_.isEmpty(advanceFilterData)}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              !values.country && delete values['country'];
              !values.state && delete values['state'];
              !values.city && delete values['city'];
              !values.oem && delete values['oem'];
              !values.charger_type && delete values['charger_type'];
              !values.access_type && delete values['access_type'];
              !values.is_active && delete values['is_active'];
              !values.charger_availibity && delete values['charger_availibity'];
              !values.zme && delete values['zme'];
              !values.last_updated_filter && delete values['last_updated_filter'];
              const filterData = {
                ...values,
                is_active: values.is_active === 'Not In Use' ? false : true,
              };
              advanceFilterDataRef.current = values;
              chargerStatus(filterData);
              handleAdvanceFilterData(values);
              setSubmitting(false);
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <Select
                    label={t('filters.country')}
                    options={_.map(allCountries, (item) => {
                      return { label: item.name, value: item.name };
                    })}
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectCountry')}
                    name="country"
                    value={values.country}
                    onMenuScrollDown={true}
                    getDataOnScrollDown={getAllCountry}
                    page={countryPage}
                    totalPage={countryTotalPage}
                    onChange={(val) => {
                      getStateByCountry({ country_name: val });
                      setFieldValue(`country`, val);
                      setFieldValue(`state`, '');
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.state')}
                    options={_.map(allState, (item) => {
                      return { label: item.name, value: item.name };
                    })}
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectState')}
                    name="state"
                    value={values.state}
                    onMenuScrollDown={true}
                    getDataOnScrollDown={(data) => getStateByCountry({ ...data, country_name: values.country })}
                    page={statePage}
                    totalPage={stateTotalPage}
                    onChange={(val) => {
                      getCityByState({ state_name: val });
                      const currentState = _.find(allState, { name: val });
                      setFieldValue(`state`, currentState.name);
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.city')}
                    options={
                      values.state &&
                      _.map(allCity, (item) => {
                        return { label: item.name, value: item.name };
                      })
                    }
                    placeholder={t('placeHolder.selectCity')}
                    name="city"
                    value={values.city}
                    onMenuScrollDown={true}
                    getDataOnScrollDown={(data) => getCityByState({ ...data, state_name: values.state })}
                    page={cityPage}
                    totalPage={cityTotalPage}
                    onChange={(val) => {
                      const currentCity = _.find(allCity, { name: val });
                      setFieldValue('city', currentCity.name);
                    }}
                  />

                  <Select
                    label="OEM Vendor Name"
                    options={_.map(allOemVendor, (item) => {
                      return { label: item.name, value: item.id };
                    })}
                    placeholder="Select OEM Vendor Name"
                    name="oem"
                    value={_.get(values, 'oem', '')}
                    onChange={(val) => setFieldValue(`oem`, val)}
                  />

                  <div className="canvas-selection__block">
                    <Select
                      label={t('filters.typeOfCharger')}
                      options={_.map(allChargeSpeed, (item) => {
                        return { label: item.name, value: item.name };
                      })}
                      placeholder={t('placeHolder.selectChargeSpeed')}
                      name="charger_type"
                      value={values.charger_type}
                      onChange={(val) => setFieldValue('charger_type', val)}
                    />
                    {/* <Select
                      label={t('filters.chargerStatus')}
                      options={[
                        { label: 'Unavailable', value: 'Unavailable' },
                        { label: 'Available', value: 'Available' },
                        { label: 'In Use', value: 'In Use' },
                      ]}
                      placeholder={t('placeHolder.selectStatus')}
                      name="charger_availibity"
                      value={values.charger_availibity}
                      onChange={(val) => setFieldValue(`charger_availibity`, val)}
                    /> */}
                    {isAllowed('getUsers') && (
                      <Select
                        label="ZME Name"
                        isMulti
                        options={_.map(allUsers, (item) => {
                          return { label: item.name, value: item.id };
                        })}
                        placeholder="Select ZME"
                        name="zme"
                        value={values.zme}
                        onChange={(val) => setFieldValue('zme', val)}
                      />
                    )}
                    <Select
                      label="Last Updated Filter"
                      disableSort
                      options={[
                        { label: 'Last 1 hour', value: 'Last 1 hour' },
                        { label: 'Last 2 hours', value: 'Last 2 hours' },
                        { label: 'Last 4 hours', value: 'Last 4 hours' },
                        { label: 'Last 6 hours', value: 'Last 6 hours' },
                        { label: 'Last 24 hours', value: 'Last 24 hours' },
                      ]}
                      placeholder="Select Last Updated"
                      name="last_updated_filter"
                      value={values.last_updated_filter}
                      onChange={(val) => setFieldValue('last_updated_filter', val)}
                    />
                  </div>
                </div>
                <div className="canvas-btn__block">
                  <Button type="submit" className="apply--btn w-100">
                    {t('button.applyFilters')}
                  </Button>
                  <div
                    className="reset--block"
                    onClick={() => {
                      setAdvanceFilterData({});
                      advanceFilterDataRef.current = {};
                      chargerStatus({ _clearAdvanceFilter: true });
                      resetForm();
                      onCloseAdvanceFilterPopup();
                    }}
                  >
                    <MdClear size={24} className="reset--icon" />
                    {t('button.clear')}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </OffCanvas>
      )}
      {
        showForm && (
          <Modal show={showForm} size="lg" centered>
            <VRNForm onClose={() => setShowForm(false)} connectorId={gunId} chargerID={chargeId} onSuccess={chargerStatus} />
          </Modal>
        )
      }
    </>
  );
};


export default ChargerStatus;